import Theme from "/components/Theme";
import Hero from "/components/organisms/common/Hero";
import WideCTA from "/components/organisms/common/WideCTA";
import People from "/components/organisms/common/People";
import FeaturedImage from "../../components/organisms/common/FeaturedImage";
import DoubleBox from "../../components/organisms/common/DoubleBox";
import GuidesKeyItems from "../../components/organisms/guides/GuidesKeyItems";
import AppStorage from "../../components/AppStorage";
import TpWidget from "../../components/atoms/document/TpWidget";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../styles/cssinjs/helpers/variables.js";

export async function getStaticProps(ctx) {
  const { locale } = ctx;
  let allData = {};
  let pageName = "what-is-premium";

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );
  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/guides/${pageName}/marketing.json`
  );
  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/guides/${pageName}/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();
  allData.footer = await footerResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
    },
  };
}

// Sections
const SecondFold = ({ data }) => {
  return (
    <section className="bg-light lg:pt-10 lg:pb-10 md:pt-4 md:pb-5">
      <FeaturedImage data={data} imageAlign="left" contentAlign="middle" />
    </section>
  );
};

const InsideGuides = ({ data }) => {
  return (
    <section className="lg:mt-20 lg:mb-20 md:mt-5 md:mb-10">
      <FeaturedImage data={data} imageAlign="right" contentAlign="middle" />
    </section>
  );
};
export default function Index({ data, nonce }) {
  const seo = data.seo;
  const header = data.header;
  const footer = data.footer;
  const content = data.content;

  return (
    <>
      <Theme
        header={header}
        footer={footer}
        seo={seo}
        nonce={nonce}
        className={`${content.helpers.pagename}`}
      >
        <AppStorage pageName={`Guides Sub Page - what-is-premium`} />
        <Hero data={content.hero} />
        <SecondFold data={content.secondFold} />
        <InsideGuides data={content.insideGuides} />
        <GuidesKeyItems data={content.guidesKeyItems} />
        <DoubleBox
          data={content.doubleBox}
          className="lg:mt-20 lg:mb-20 md:mt-10 md:mb-10"
        />
        <People className="lg:pt-10" />
        <WideCTA data={content.wideCTA} />
        <style global jsx>
          {`
            @media (min-width: ${viewport.tablet.sm}) {
              .guides-page .card--default.card--feature.has-four-col > * {
                width: calc((100% - 120px) / 4);
              }
              .guides-page
                .card--default.card--feature
                .icon-title-wrap
                figure {
                margin-left: auto;
                margin-right: auto;
              }
              .guides-page .card--default.card--feature .icon-title-wrap p {
                max-width: 190px;
                text-align: center;
                margin: 25px auto 0 auto;
                padding: 0;
              }
            }
            .guides-page .cta-w-image .btn-primary {
              padding: 12px 40px;
            }
            .guides-page .cta-w-image figure {
              position: relative;
              border-radius: 8px;
              background-color: ${colors.primitive.yellow[100]};
            }
          `}
        </style>
        <TpWidget />
      </Theme>
    </>
  );
}
